export default "__VITE_ASSET__6ed5ff23__"